const Needle = ({ currentTime, handleMouseDown }) => {
    return (
        <>
            <div
                className="tw:absolute tw:-top-1.5 tw:w-0.5 tw:h-10 tw:bg-white tw:pointer-events-none"
                style={{
                    left: `${currentTime}%`,
                    transform: 'translateX(-3px)',
                }}
            />

            {/* Playhead Handle */}
            <div
                className="tw:absolute tw:w-4 tw:h-4 tw:bg-white tw:rounded-full tw:cursor-grab tw:border-2 tw:border-blue-300"
                style={{
                    left: `${currentTime}%`,
                    top: '-22px',
                    transform: 'translateX(-10px)',
                }}
                onMouseDown={(e) => handleMouseDown(e, 'playhead')}
            />
        </>
    )
}

export default Needle
